import(/* webpackMode: "eager" */ "/home/runner/work/dogs-blog/dogs-blog/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dogs-blog/dogs-blog/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dogs-blog/dogs-blog/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dogs-blog/dogs-blog/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/components/common/google-ad/InArticle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/components/common/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/components/post/CoverPictureOwnerAttribute.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dogs-blog/dogs-blog/src/components/post/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/features/comments/ui/Comment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/buttons/BackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/buttons/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/call-to-number/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/HiddenLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/theme/index.tsx");
